import React from "react";
import { useNavigate, useParams } from "react-router-dom";

// import AstrobeeMissionControl from "./AstrobeeMissionControlVNC";

// import IntBall2MissionControl from "./IntBall2MissionControlVNC";

// import SPHERESMissionControl from "./SpheresMissionControl";

import RobotMissionControl from "./RobotMissionControl"

export default function Simulation() {
    const { lab_id } = useParams();
    const { projectId } = useParams();
    const navigate = useNavigate();
    const [vncUrl, setVncUrl] = React.useState("");
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        async function start() {
            try {
                const res =
                    await fetch(
                        "/api/simulate",
                        {
                            method: "POST",
                            credentials:
                                "include",
                            headers: {
                                "Content-Type":
                                    "application/json",
                            },
                            body: JSON.stringify({
                                lab_id:
                                    lab_id,
                            }),
                        }
                    );

                const data = await res.json();
                if (!res.ok) {
                    throw new Error(
                        data.message ||
                        "Failed to start simulation"
                    );
                }
                if (!data.vncUrl) {
                    throw new Error(
                        "No VNC URL returned"
                    );
                }
                setVncUrl(
                    data.vncUrl
                );

            } catch (error) {
                console.error(
                    error
                );
                navigate(
                    `/rect/ide/${lab_id}/${projectId}`
                );
            } finally {
                setLoading(false);
            }
        }

        start();

    }, [lab_id, navigate]);


    if (loading) {

        return (
            <div
                style={{
                    width: "100vw",
                    height: "100vh",
                    background: "#000",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                Starting simulation...
            </div>
        );
    }


    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                width: "100vw",
                height: "100vh",
                background: "#000",
                overflow: "hidden",
            }}
        >

            <RobotMissionControl
                    vncUrl={vncUrl}
                />
        </div>
    );
}